export { default } from "../.internal/themes/animated";
//# sourceMappingURL=animated.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amcharts/amcharts4/themes/animated.js
// module id = null
// module chunks = 